import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        winner: PropTypes.string
    };

    componentDidUpdate(prevProps) {
        /* eslint-disable no-undef */
        const { content } = this.props;

        if (content !== prevProps.content) {
            TweenLite.fromTo(
                '#left',
                0.5,
                { left: '-750px' },
                {
                    left: 0,
                    onComplete: () => {
                        TweenLite.fromTo(
                            '#left_cover',
                            1,
                            { opacity: 1 },
                            {
                                opacity: 0,
                            },
                        );
                        this.animateNum(document.querySelector('#leftNum'), content.biden, 0);
                    },
                },
            );

            TweenLite.fromTo(
                '#right',
                0.5,
                { right: '-447px' },
                {
                    right: 0,
                    onComplete: () => {
                        TweenLite.fromTo(
                            '#right_cover',
                            1,
                            { opacity: 1 },
                            {
                                opacity: 0,
                            },
                        );
                        this.animateNum(document.querySelector('#rightNum'), content.trump, 0);
                    },
                },
            );
        }
        /* eslint-enable no-undef */
    }

    animateNum = (dom, val, dot) => {
        const obj = {
            num1: dom.innerHTML,
        };

        /* eslint-disable no-undef */
        TweenLite.to(obj, 0.9, {
            num1: val,
            onUpdate: () => {
                if (obj.num1.toFixed) {
                    dom.innerHTML = obj.num1.toFixed(dot);
                }
            },
            delay: 0,
        });
        /* eslint-enable no-undef */
    };

    render() {
        const { winner, content } = this.props;
        let styleLeft = styles.left;
        let styleRight = styles.right;

        if((content.biden && parseInt(content.biden) >= 270) || winner === 'biden') {
            styleLeft = styles.bidenleft;
            styleRight = styles.bidenright
        }

        if((content.trump && parseInt(content.trump) >= 270) || winner === 'trump') {
            styleLeft = styles.trumpleft;
            styleRight = styles.trumpright
        }

        return (
            <div className={styles.banner}>
                <div className={styles.banner_box}>
                    <img
                        className={styles.bannerBgPic}
                        src="http://x0.ifengimg.com/cmpp/2020/1022/983d7146f727034size99_w750_h450.png"
                    />
                    <span className={styles.logo} />
                    <div id="left" className={styleLeft}>
                        <div id="left_cover" />
                        <div className={styles.num}>
                            <span id="leftNum">0</span>
                        </div>
                        <div id="biden" />
                    </div>
                    <div id="right" className={styleRight}>
                        <div id="right_cover" />
                        <div className={styles.num}>
                            <span id="rightNum">0</span>
                        </div>
                        <div id="trump" />
                    </div>
                    <div className={styles.title} />
                    <div className={styles.mark} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Banner);
